function assertKeepAwakeEnabled(value) {
  if (typeof value !== "boolean") {
    throw new Error("KeepAwake.setEnabled: enabled must be a boolean");
  }
}
var keepAwakeDefaultTag = "ExpoKeepAwakeDefaultTag";
function assertKeepAwakeTag(value, owner) {
  if (value !== void 0 && typeof value !== "string") {
    throw new Error(`KeepAwake.${owner}: tag must be a string`);
  }
}
function normalizeKeepAwakeTag(value) {
  return value !== null && value !== void 0 ? value : keepAwakeDefaultTag;
}
export {
  assertKeepAwakeEnabled,
  assertKeepAwakeTag,
  keepAwakeDefaultTag,
  normalizeKeepAwakeTag
};
//# sourceMappingURL=validate.js.map
